import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { CameraIcon, Loader } from 'components';
import classnames from 'classnames';
import './style.scss';

// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated This component is deprecated.
 */
export class UploadImageSimpleField extends PureComponent {
  static propTypes = {
    imageUrl: PropTypes.string,
    name: PropTypes.string,
    accept: PropTypes.string,
    onDrop: PropTypes.func,
    isShowLoader: PropTypes.bool,
  };

  static defaultProps = {
    imageUrl: '',
    name: '',
    accept: 'image/*',
    onDrop: () => {},
    isShowLoader: false,
  };

  inputRef = React.createRef();

  openFileDialog = () => {
    this.inputRef.current.click();
  };

  onDrop = (event) => {
    const { onDrop } = this.props;
    onDrop(event.target.files[0]);

    this.inputRef.current.value = '';
  };

  render() {
    const { imageUrl, isShowLoader, name, accept } = this.props;

    return (
      <div
        className={classnames('upload-area-wrapper', { 'mb-5': !!imageUrl })}
      >
        <Loader isShow={isShowLoader} smallLoader centeredLoader>
          <div className="upload-area">
            {imageUrl ? (
              <>
                <div
                  className="upload-area__image"
                  style={{
                    backgroundImage: `url(${imageUrl})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                  }}
                />
                <div
                  className="upload-area__reupload"
                  onClick={this.openFileDialog}
                >
                  <CameraIcon className="upload-area__icon" />
                </div>
              </>
            ) : (
              <div className="upload-avatar" onClick={this.openFileDialog}>
                <div className="upload-avatar__wrapper">
                  <CameraIcon className="upload-avatar__icon" />
                  <span className="upload-avatar__text">Upload</span>
                </div>
              </div>
            )}
            <input
              className="upload-avatar__input"
              type="file"
              accept={accept}
              name={name}
              ref={this.inputRef}
              onChange={this.onDrop}
              multiple={false}
            />
          </div>
        </Loader>
      </div>
    );
  }
}
